import Vue from "vue";
import Vuex from "vuex";
import { vuexOidcCreateStoreModule } from "vuex-oidc";
import paging from "./modules/paging";
import global from "./modules/global";

const dotenv = require("dotenv");
dotenv.config();

Vue.use(Vuex);

console.log("Authority_Url = " + process.env.VUE_APP_AUTHORITY_URL);

let oidcSettings = {
  authority: window.location.origin.replace(".omnigo.one", ".auth.omnigo.one").replace("auth-", "").replace("adminui-", "adminui.").replace("http://localhost:5001", "https://adminui.dev.auth.omnigo.one"),
  clientId: "26CFD36D09434DCBB2CF897744B4E638",
  response_type: "code",
  scope: "openid profile Admin.ReadWrite",

  redirectUri: window.location.origin + "/oidc-callback",
  popupRedirectUri: window.location.origin + "/oidc-popup-callback",
  postLogoutRedirectUri: window.location.origin,
  loadUserInfo: true,
  automaticSilentSignin: false,
  automaticSilentRenew: false,
  //silentRedirectUri: window.location.origin + "/silent-renew-oidc.html",
  //filterProtocolClaims: true,
 };

const store = new Vuex.Store({
  state: {
    tenantFilter: ""
  },
  getters: {},
  mutations: {
    setTenantFilter(state, tenantFilter) {
        state.tenantFilter = tenantFilter;
    }
  },
  actions: {},
  modules: {
    global,
    paging,
    oidcStore: vuexOidcCreateStoreModule(
      oidcSettings,
      // Optional OIDC store settings
      {
        namespaced: true,
        //isAuthenticatedBy: 'access_token',
        dispatchEventsOnWindow: true
      },
      // Optional OIDC event listeners
      {
        userLoaded: user => console.log("OIDC user is loaded:", user),
        userUnloaded: () => console.log("OIDC user is unloaded"),
        accessTokenExpiring: () => console.log("OIDC Access token expiring..."),
        accessTokenExpired: () => {
          console.log("OIDC Access token expired");
        },
        silentRenewError: () => console.log("OIDC user is unloaded"),
        userSignedOut: () => console.log("OIDC user is signed out"),
        oidcError: payload => console.log("OIDC error", payload),
        automaticSilentRenewError: payload =>
          console.log("OIDC automaticSilentRenewError", payload)
      }
    )
  }
});

export default store;
